function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
class CollapsableContent extends HTMLElement {
  constructor() {
    super();
    if ( this.querySelector(':scope > h2, :scope > p.footer-block__heading') ) {
      this.querySelector(':scope > h2, :scope > p.footer-block__heading').addEventListener('click', this.toggleCollapse.bind(this), false);
    }
  }
  toggleCollapse() {
    if (this.hasAttribute('open')) {
      this.removeAttribute('open', true);
      return;
    }
    this.setAttribute('open', true);
  }
}

customElements.define('collapsable-content', CollapsableContent);


document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if(summary.nextElementSibling) {
      if(summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);          
      }
    }

      summary.addEventListener('click', (event) => {           
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        
        let menubtns = document.querySelectorAll('[data-menubtn]');
        
          if (event.currentTarget.hasAttribute('data-menubtn')) {
            menubtns.forEach(btn => {
              btn.classList.remove('g-btn-fill-primary');
              btn.classList.remove('g-btn-fill-primary1');                   
            });
          }
        
          if (event.currentTarget.hasAttribute('data-menubtn')) {          
            if(event.classList.contains('g-btn-fill-primary1')) {
              event.classList.remove('g-btn-fill-primary1');
            }
            event.currentTarget.classList.remove('g-btn-outline-secondary');
            event.currentTarget.classList.add('g-btn-fill-primary');                              
          }
      });
    

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
function updatePreviousValue(newValue) {
  window.previousValue = newValue;

  const event = new CustomEvent('previousValueUpdated', { detail: { newValue } });
  window.dispatchEvent(event); // Dispatch the event to the window object
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
    window.previousValue = 1;
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    if (typeof window.previousValue === 'undefined') {
      updatePreviousValue(1); 
    }
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
    window.previousValue = parseInt(this.input.value) || 0;

  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    let newValue = (typeof previousValue !== 'undefined' ? parseInt(previousValue) : 0) + 1;
    newValue = parseInt(newValue) + window.totalCartQuantity;
    // TODO: refactor to provide value:
    updatePreviousValue(newValue);

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

        if (previousValue !== this.input.value) {
          this.input.dispatchEvent(this.changeEvent);
          let newValue = parseInt(this.input.value) || 0;
          newValue = parseInt(newValue) + window.totalCartQuantity;
          updatePreviousValue(newValue);
        }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};


class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    // document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    // document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dotContainer = this.querySelector('.slider-dots__pdp');
    this.swatchContainer = this.querySelector('.slider-swatches');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    
    if (this.sliderItemsToShow.length < 2) return;

    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = Math.ceil(this.sliderItemsToShow.length / this.slidesPerPage);
   
    const isScrollable =  this.sliderItemsToShow.length > 6;
   
    if(window.innerWidth > 750) {
    if (isScrollable) {
      this.createDots();
       this.prevButton.style.display = isScrollable ? 'block' : 'none';
    this.nextButton.style.display = isScrollable ? 'block' : 'none';
    } else if (this.dotContainer) {
      this.dotContainer.innerHTML = '';
    }
    }

    this.createSwatches();
    this.update();
  }
createSwatches() {
  if (!this.swatchContainer) return;
  this.swatchContainer.innerHTML = '';
  this.sliderItemsToShow.forEach((_, index) => {
    const swatch = document.createElement('span');
    swatch.classList.add('slider-swatch');
    if (index === 0) swatch.classList.add('slider-swatch--active');
    this.swatchContainer.appendChild(swatch);
  });
}

updateSwatches() {
  if (!this.swatchContainer) return;
  const swatches = this.swatchContainer.querySelectorAll('.slider-swatch');
  swatches.forEach((swatch, index) => {
    swatch.classList.toggle('slider-swatch--active', index === this.currentPage - 1);
  });
}

createDots() {
    if (!this.dotContainer) return;
    this.dotContainer.innerHTML = '';
    for (let i = 0; i < this.totalPages; i++) {
      const dot = document.createElement('button');
      dot.classList.add('slider-dot');
      if (i === 0) dot.classList.add('active');
      dot.dataset.index = i + 1;
      dot.addEventListener('click', () => this.goToPage(i + 1));
      this.dotContainer.appendChild(dot);
    }
  }

goToPage(pageNumber) {
  const position = (pageNumber - 1) * this.sliderItemOffset * this.slidesPerPage;
  this.setSlidePosition(position);

  // Update active dot
  if (this.dotContainer) {
    const dots = this.dotContainer.querySelectorAll('.slider-dot');
    dots.forEach(dot => dot.classList.remove('active'));
    const activeDot = Array.from(dots).find(dot => parseInt(dot.dataset.index, 10) === pageNumber);
    if (activeDot) activeDot.classList.add('active');
  }

  // Also update current page number if those elements exist
  if (this.currentPageElement && this.pageTotalElement) {
    this.currentPageElement.textContent = pageNumber;
    this.pageTotalElement.textContent = this.totalPages;
  }
}


updateDots(arrow) {  
  if (!this.dotContainer) return;
  const dots = this.dotContainer.querySelectorAll('.slider-dot');
  const activeDot = Array.from(dots).find(dot => dot.classList.contains('active'));
  if (activeDot) { 
    const activeIndex = Array.from(dots).findIndex(dot => dot === activeDot);
    activeDot.classList.remove('active');

    if (arrow == 'prev' && dots[activeIndex-1]) {
      dots[activeIndex-1].classList.add('active');
    } else if (arrow == 'next' && dots[activeIndex+1]) {
      dots[activeIndex+1].classList.add('active');
    } else {
      dots[activeIndex].classList.add('active')
    }
  }
}

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    this.updateSwatches();

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    const mediaQuery = window.matchMedia('(min-width: 750px)');

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      if (this.prevButton) this.prevButton.setAttribute('disabled', 'disabled');
      if (mediaQuery.matches && this.querySelector('.slider__header .collection__view-all')) {
        this.querySelector('.slider__header .collection__view-all').classList.add('transparent');
      }
    } else {
      if (this.prevButton) this.prevButton.removeAttribute('disabled');
      if (this.querySelector('.slider__header .collection__view-all')) {
        this.querySelector('.slider__header .collection__view-all').classList.remove('transparent');
      }
    }
    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      if (this.nextButton) this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      if (this.nextButton) this.nextButton.removeAttribute('disabled');
    }

    if (this.currentPageElement && this.pageTotalElement) {
      const currentPage = parseInt(this.currentPageElement.textContent, 10);
      const totalPages = parseInt(this.pageTotalElement.textContent, 10);

      const isFirstPage = currentPage === 1;
      const isLastPage = currentPage === totalPages;

      // if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      if (isFirstPage) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      // if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      if (isLastPage) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {    
    event.preventDefault();
    const step = parseInt(event.currentTarget.dataset.step || 1, 10);
    const moveBy = this.sliderItemOffset * this.slidesPerPage;   

    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + moveBy
        : this.slider.scrollLeft - moveBy;

    this.currentPage = Math.round(this.slideScrollPosition / (this.sliderItemOffset * this.slidesPerPage)) + 1;
    this.setSlidePosition(this.slideScrollPosition);
    

    event.currentTarget.name === 'next'
      ?  this.updateDots('next')
      :  this.updateDots('prev');  

    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], .fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

//test :
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = ((number)/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents.replace('00', '-');
  }
  
  // switch(formatString.match(placeholderRegex)[1]) {
  //   case 'amount':
  //     value = formatWithDelimiters(cents, 2);
  //     break;
  //   case 'amount_no_decimals':
  //     value = formatWithDelimiters(cents, 0);
  //     break;
  //   case 'amount_with_comma_separator':
  //     value = formatWithDelimiters(cents, 2, '.', ',');
  //     break;
  //   case 'amount_no_decimals_with_comma_separator':
  //     value = formatWithDelimiters(cents, 0, '.', ',');
  //     break;
  // }
  value = formatWithDelimiters(cents, 2, '.', ',');
  return formatString.replace(placeholderRegex, value);
};

class AuthToken {
  async getToken() {
    const userId = localStorage.getItem("usersIds");
    if(!userId){
        localStorage.removeItem("authToken");
    
    function uuidv4() {
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    
    }
        const uuid = uuidv4();
    localStorage.setItem("usersIds", uuid);
    }
    const authToken = localStorage.getItem('authToken');
    if (authToken && this.isTokenValid()) {
      return authToken;
    }

    const {token, expiresAt} = await this.fetchToken() || {};
    localStorage.setItem('authToken', token);
    localStorage.setItem('authTokenExpiredAt', expiresAt);

    return token;
  }

  isTokenValid() {
    const FIVE_MINUTES = 300000;
    return this.timeToExpired() > FIVE_MINUTES;
  }

  timeToExpired() {
    const authTokenExpiredAt = localStorage.getItem('authTokenExpiredAt')
    if (!authTokenExpiredAt) {
      return 0;
    }

    const timeToExpired = new Date(authTokenExpiredAt).getTime() - new Date().getTime();
    return Math.max(timeToExpired, 0);
  }
  
  async fetchToken(retry = 0) {
    try {
      const headers = new Headers();
      const users = localStorage.getItem("usersIds")   
      headers.append("Authorization", `Bearer ${window.escJwt.token}`);
     if (window.customerId == null) {
       headers.append("x-customerId", users);
       headers.append("x-isLoggedIn",window.Shopify.userIsLoggedIn);
       headers.append("x-oldCustomerId",users);
      } 
    else {
       headers.append("x-customerId", window.customerId);
       headers.append("x-isLoggedIn",window.Shopify.userIsLoggedIn);
       headers.append("x-oldCustomerId",users);    
       }
        // if (window.customerId) {
        //   headers.append("x-customerId", window.customerId)
        // }
      const requestOptions = {
        method: 'POST',
        headers,
        redirect: 'follow'
      };
      
      var adapterFunctionTokenUrl = "";
      switch(window.Shopify.shop){
       case 'levi9testtheme.myshopify.com':
         adapterFunctionTokenUrl = "https://func-shopifyadapter-dev-northeu-001.azurewebsites.net/api/Token";
          break;
       case 'shirtup-online.myshopify.com':
         adapterFunctionTokenUrl = "https://func-shopifyadapter-prd-northeu-001.azurewebsites.net/api/Token";
          break;
       case 'shirtupstaging.myshopify.com':
         adapterFunctionTokenUrl = "https://func-shopifyadapter-uat-northeu-001.azurewebsites.net/api/Token";
          break;
      }
      const response = await fetch(adapterFunctionTokenUrl, requestOptions);
            if (retry > 3) {
              console.log("Failed to fetch token")
              return {}       
      }

      if (response.status === 401) {
        await this.refreshToken();
        return await this.fetchToken(retry + 1);     
      }
      return await response.json(); 
    } catch (error) {
      console.log(error);
    }
  }

  async refreshToken() {
    return await fetch(window.Shopify.routes.root + "?sections=token-section")
        .then(res => res.json())
        .then(res => {
          const tokenMatch = res['token-section'].match(/token:\s*"([^"]+)/);
          const expiredAtMatch = res['token-section'].match(/expiredAt:\s*"([^"]+)/);
          const token = tokenMatch && tokenMatch[1];
          const expiredAt = expiredAtMatch && expiredAtMatch[1];
          window.escJwt = { token, expiredAt }
        });
  }
}

(async function () {
  try {
    const authToken = new AuthToken();
    await authToken.getToken();
  } catch (error) {
    console.log(error);
  }
})();


class RedirectToConfigurator {
  constructor() {
    if (Shopify.userIsLoggedIn && localStorage.getItem("redirect_product") && localStorage.getItem("redirect_configurator_design_id")) {
      this.init();
    }
  }
  async init() {
    const langMarket = Shopify.routes.root;
    const activeUrl = window.location.pathname + window.location.search;
    const redirectProduct = localStorage.getItem("redirect_product");
    const redirectConfiguratorDesignId = localStorage.getItem("redirect_configurator_design_id");
    const redirectVariant = localStorage.getItem("redirect_variant");
    var url = `${langMarket}products/${redirectProduct}?_configurator_design_id=${redirectConfiguratorDesignId}`;
    if (redirectVariant) {
      url = `${langMarket}products/${redirectProduct}?variant=${redirectVariant}&_configurator_design_id=${redirectConfiguratorDesignId}`;
      
    }
    if (activeUrl.includes(url)) {
      localStorage.removeItem('redirect_product');
      localStorage.removeItem('redirect_configurator_design_id');
      localStorage.removeItem('redirect_variant');
    } else {
        try{
          const authToken = new AuthToken();
          let token = await authToken.getToken();
          window.location.replace(url);
        } catch (error) {
          console.log(error)
        }   
    }
  }
};
new RedirectToConfigurator();


class ProductConfigurator extends HTMLElement {
  constructor() {
      super();
      this.authToken = new AuthToken();
      this.addEventListener('shirtup:configure', this.initialiseData.bind(this));
      this.addEventListener('shirtup:render', this.renderConfigurator.bind(this));
      this.addEventListener('shirtup:update', this.updateData.bind(this));
      this.addEventListener('shirtup:updateSizes', this.updateSizes.bind(this));
      this.addEventListener('shirtup:updatePrintTechnique', this.updatePrintTechnique.bind(this));
      if (this.querySelector('[data-close]')) {
          this.querySelector('[data-close]').addEventListener('click', this.closeConfigurator.bind(this));
      }

      this.configurator = this.querySelector('shirtup-configurator');
      this.cartItemsToUpdate = [];
      this.readyToRedirect = true;
      this.printingPrice = 0;
      this.premiumGraphics = 0;
    
  }
  
  initialiseData(ev) {
      this.updateConfiguratorData(ev.detail);
      this.renderConfigurator();
  }

  updatePrintTechnique(ev) {
    let printingType = ev.detail.selectedTechnique;  
    let colorPickerElement = document.querySelector('.colorEN:checked');
    let colorEN=colorPickerElement.dataset.configuratorcolor;
    
      // Get configurator data, initialize if not already set
    this.configuratorData = this.configuratorData || this.getConfiguratorData();
    this.configuratorData.printingTechnique = printingType;

    window.printingTechnique = printingType;
    
    const updatedVariants = this.configuratorData.product.variants.map(variant => {
  
          return {
              id: variant.id,
              color: colorEN,
              size: variant.size,
              sku: variant.sku,
              price: variant.price,
              available: variant.available,            
          };
      });
  
      const updatedValues = {
          product: {
              ...this.configuratorData.product,
              variants: updatedVariants, 
            printTechnique: window.printingTechnique
          },
      };

    // Apply the updated configurator data
    this.updateConfiguratorData(updatedValues);
  }

updateSizes(ev) {
  const preselectedSizes = ev.detail.preselectedSizes;
  let colorPickerElement = document.querySelector('.colorEN:checked');
  let colorEN = colorPickerElement.dataset.configuratorcolor;

  this.configuratorData = this.configuratorData || this.getConfiguratorData();

  const updatedVariants = this.configuratorData.product.variants.map(variant => {
    const isSelected = preselectedSizes.includes(variant.size);

    // Read actual quantity from the sizeQuantities map sent by sendPreselectedSizesOnly()
    const qty = (ev.detail.sizeQuantities || {})[variant.size] || 0;

    return {
      id: variant.id,
      color: colorEN,
      size: variant.size,
      sku: variant.sku,
      price: variant.price,
      available: variant.available,
      selectedQuantity: isSelected ? (qty || 1) : 0,
    };
  });

  const updatedValues = {
    product: {
      ...this.configuratorData.product,
      preselectedVariants: ev.detail.sizeQuantities || {},
      variants: updatedVariants,
    },
  };

  this.updateConfiguratorData(updatedValues);
}

  async fetchAllTranslatedProductTitles() {
    const GRAPHQL_ENDPOINT = `https://${window.location.host}/api/2023-10/graphql.json`;
    const STOREFRONT_ACCESS_TOKEN = "8ed4adeb081cc2c1365d4ef15ebee2f2"; 
  
    const TAG_FILTER = 'tag:Designyourown';
    const LANGUAGE = Shopify.locale.toUpperCase();
    const COUNTRY = Shopify.country.toUpperCase();
  
    const query = `
      query getTranslatedProducts($tag: String!, $country: CountryCode, $language: LanguageCode, $cursor: String)
        @inContext(country: $country, language: $language) {
        products(first: 250, query: $tag, after: $cursor) {
          edges {
            cursor
            node {
              title
              globalid: metafield(namespace: "custom", key: "globalid") {
                value
              }
            }
          }
          pageInfo {
            hasNextPage
          }
        }
      }
    `;
  
    let hasNextPage = true;
    let cursor = null;
    const productTitleTranslations = {};
  
    while (hasNextPage) {
      const response = await fetch(GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
        },
        body: JSON.stringify({
          query,
          variables: {
            tag: TAG_FILTER,
            country: COUNTRY,
            language: LANGUAGE,
            cursor
          }
        })
      });
  
      const json = await response.json();
  
      if (json.errors) {
        console.error('Errors:', json.errors);
        break;
      }
  
      const edges = json?.data?.products?.edges || [];
  
      for (const edge of edges) {
        const globalid = edge.node.globalid?.value;
        const title = edge.node.title;
        if (globalid && title) {
          productTitleTranslations[globalid] = title;
        }
      }
  
      hasNextPage = json?.data?.products?.pageInfo?.hasNextPage;
      cursor = edges.length > 0 ? edges[edges.length - 1].cursor : null;
    }
  
    this.configurator.productTitleTranslations = productTitleTranslations;
    return productTitleTranslations;
  }


  updateData(ev) {
    let colorPickerElement = document.querySelector('.colorEN:checked');
    let colorEN=colorPickerElement.dataset.configuratorcolor;
    let colorTranslated=colorPickerElement.value;

    this.configuratorData = (this.configuratorData) ? this.configuratorData : this.getConfiguratorData();
    const variants = ev.detail.variants.map(v => {
        const altVariant = this.configuratorData.product.variants.find(av => av.size == v.option2);
        // let isPreselected = ev.detail.preselectedVariants.includes(v.id);
        // let variantQuantity = isPreselected ? 1 : 0;

        return {
            id: v.id,
            color: colorEN,
            size: v.option2,
            sku: v.sku,
            price: v.price,
            available: v.available,
            // selectedQuantity: variantQuantity,
            
        };
    });
    const updatedValues = {
        variants: variants,
        product: {
            preselectedVariants: ev.detail.preselectedVariants,
            color: colorEN,
            productColorTranslation: colorTranslated,
            variants: variants
        }
    };
    this.updateConfiguratorData(updatedValues);
  }

 async closeConfigurator(e) {
    if(this.readyToRedirect === true){
            
      if (typeof URLSearchParams !== 'undefined') {
        const params = (new URL(document.location)).searchParams;
        if (params.has('_configurator_design_id')) {
          params.delete('_configurator_design_id');
          params.set('variant',this.configuratorData.variants[0].id);
          if (params.has('readOnly')) {
            params.delete('readOnly');
          }
          window.history.replaceState( {} , document.title, '?' + params.toString() );
        }
      } else {
        window.history.replaceState( {} , document.title, '?browser=unsupported' );
      }      

      if (this.checkTokenIntervalId) {
        clearInterval(this.checkTokenIntervalId);
      }

      if(window.location.toString().includes("saved-designs")){
        const event = new CustomEvent("saved-design-refetch",{
          bubbles:true
        });
        window.dispatchEvent(event) 
       } else {        
        const url = new URL(window.location);
        
         await fetch(url + "?section=main-product")
          .then((response) => response.text())
          .then((responseText) => {
            const htmlParsed = new DOMParser().parseFromString(responseText, 'text/html');
            const configuratorElement = htmlParsed.querySelector('#ConfiguratorJSON');
        
            if (configuratorElement) {
              const configData = JSON.parse(configuratorElement.innerHTML);
        
              const originalConfigurator = document.querySelector('#ConfiguratorJSON');
              if (originalConfigurator) {
                originalConfigurator.innerHTML = JSON.stringify(configData);
              }
            } else {
              console.warn('No #ConfiguratorJSON element found in response');
            }
            this.configuratorData = this.getInitialConfiguratorData();            
          })
          .catch((e) => {
            console.error('Error fetching data:', e);
          });
       }
      
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-two');
      if (this.configurator) this.configurator.remove();
      this.configurator = null;
      
      }
     else{
        setTimeout(() => {
          this.closeConfigurator();
      }, 500);
  }

   setTimeout(()=>{
        const trustBadge = document.querySelector('._1y0juye');
        
        if (trustBadge) {
          trustBadge.style.removeProperty("display");
        }
      }, 3000);
}

  async renderConfigurator(e) {
      document.body.classList.add('overflow-hidden');
      document.body.classList.add('overflow-two');
      this.setAttribute('open', true);
      if (!this.configurator) {
          this.configurator = document.createElement('shirtup-configurator');
          this.appendChild(this.configurator);
          await this.init();
          this.addEventListeners();
      }

      setTimeout(()=>{
        const trustBadge = document.querySelector('._1y0juye');
        
        if (trustBadge) {
          trustBadge.style.setProperty("display", "none", "important");
        }
      }, 3000);
  }
/*
  async checkCartContents() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      const designIdExists = cart.items.some(item => item.properties._configurator_design_id === this.configuratorData.configuratorDesignId);
      this.configuratorData.fromCart = designIdExists;

    } catch (error) {
      console.error('Error fetching cart contents:', error);
    }
  }
*/
  addEventListeners() {
      this.configurator.addEventListener('onpricingrequested', this.pricingRequested.bind(this));
      this.configurator.addEventListener('onprinttechniquechange', this.reinitializeComponent.bind(this));
      this.configurator.addEventListener('onaddtocart', this.generateCart.bind(this));
      this.configurator.addEventListener('ondesigniscreated', this.designIdUpdate.bind(this));
      this.configurator.addEventListener('onconfiguratorclose', this.closeConfigurator.bind(this));
      this.configurator.addEventListener('onreplaceproduct', this.replaceProduct.bind(this));    
      this.configurator.addEventListener('oncompleteddesign', this.sendAccountToCompletedDesignInKlaviyo.bind(this));
      this.configurator.addEventListener('onsaveddesign', this.sendAccountToSavedDesignInKlaviyo.bind(this));
      this.configurator.addEventListener('onauthconflict', this.authConflict.bind(this));
      this.configurator.addEventListener('onredirect', this.redirect.bind(this));
  }
  sendAccountToCompletedDesignInKlaviyo(e){
    let userEmail = localStorage.getItem('users_email');
    _learnq.push(['identify', {
       '$email' : userEmail
       }]);
      _learnq.push(['track', 'Completed Design']);
  }   

  partialUpdateConfiguratorData(changes) {
    if (!this.configuratorData) {
        this.configuratorData = this.getConfiguratorData();
    }
  
      this.configuratorData = this.mergeDeep(this.configuratorData, changes);
    }
  
  async reinitializeComponent(e) {    
    if (this.configurator) {
        this.configurator.remove();
        this.configurator = null;
    }
  
    const changes = {
        configuratorDesignId: e.detail.configuratorDesignId,
        product: {
            printTechnique: e.detail.printTechnique
        }
    };
  
    await this.renderConfigurator();

    setTimeout(() => {                
        this.partialUpdateConfiguratorData(changes);        
    }, 1000); 
  }
  
  async replaceProduct(e) {
    try {
      var shopifyId = await this.getShopifyProductId(e.detail.product.id);
      var variantsObject = await this.getVariants(shopifyId);
      var variantsData = variantsObject.data.product;
      var shopifyVariantIds = [];
      const productType = variantsData.productType;
  
      const variantsArray = variantsData.variants.edges.map(edge => {
        const shopifyId = edge.node.id.split('/').pop(); // Split by '/' and get the last part
        const shopifyVariantGlobalId = edge.node.globalid?.value;
        const configuratorColor = edge.node.colorEN?.value;
        const variantSku = edge.node.sku;
        // const variantPriceWithoutDot = edge.node.price.amount.replace('.', "");
        // const variantPrice = Number(variantPriceWithoutDot);
        const variantPrice = edge.node.price.amount * 100.00;
      
        shopifyVariantIds.push(shopifyId, shopifyVariantGlobalId, configuratorColor, variantSku, variantPrice);
  
        return { id: shopifyId, globalId: shopifyVariantGlobalId, color: configuratorColor, sku: variantSku, price: variantPrice };
      });

      
      this.configuratorData = this.getConfiguratorData();

      this.configuratorData.product = e.detail.product;
      this.configuratorData.productHandler = e.detail.productHandler;
      this.configuratorData.productTranslation = e.detail.productHandler;
      //example for updates printing products on replaceProduct
      if (productType === "Bag") {
        this.configuratorData.printing_variants = getHoodieProduct();
      } else {
        this.configuratorData.printing_variants = getBasePrint();
      }
      this.configuratorData.product.variantsStock = variantsArray.map(variant => ({
        id: variant.id,
        globalid: variant.globalId,
        color: variant.color,
        sku: variant.sku,
        price: variant.price
      }));
      this.configuratorData.product.variants = variantsArray.map(variant => ({
        id: variant.id,
        globalid: variant.globalId,
        color: variant.color,
        sku: variant.sku,
        price: variant.price
      }));
      this.configuratorData.variants = variantsArray.map(variant => ({
        id: variant.id,
        globalid: variant.globalId,
        color: variant.color,
        sku: variant.sku,
        price: variant.price
      }));

    } catch (error) {
      console.error("Error replacing product:", error);
    }
  }
  
  async getShopifyProductId(productGlobalId) {
    var adapterFunctionTokenUrl = "";
    switch(window.Shopify.shop){
     case 'levi9testtheme.myshopify.com':
       adapterFunctionTokenUrl = `https://func-shopifyadapter-dev-northeu-001.azurewebsites.net/api/GetShopifyProductId?globalId=${productGlobalId}`;
        break;
     case 'shirtup-online.myshopify.com':
       adapterFunctionTokenUrl = `https://func-shopifyadapter-prd-northeu-001.azurewebsites.net/api/GetShopifyProductId?globalId=${productGlobalId}`;
        break;
     case 'shirtupstaging.myshopify.com':
       adapterFunctionTokenUrl = `https://func-shopifyadapter-uat-northeu-001.azurewebsites.net/api/GetShopifyProductId?globalId=${productGlobalId}`;
        break;
    }
    try {
      const response = await fetch(adapterFunctionTokenUrl);
      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }
      const data = await response.json();
      return data; 
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
    }
  }
  async getVariants(shopifyId) {
    const language=Shopify.country.toUpperCase();
    let graphQlToken = "";
    switch (window.Shopify.shop) {
      case 'levi9testtheme.myshopify.com':
        graphQlToken = "98fdd58a48bcdc250a2a279a08f800e2";
        break;
      case 'shirtup-online.myshopify.com':
        graphQlToken = "8ed4adeb081cc2c1365d4ef15ebee2f2";
        break;
      case 'shirtupstaging.myshopify.com':
        graphQlToken = "b5deea45294c65b32c165d63fa61179e";
        break;
    }
    try {
      const response = await fetch(`https://${window.location.host}/api/2023-10/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': graphQlToken
        },
        body: JSON.stringify({
          query: `query @inContext(country: ${language}) {
            product(id: "gid://shopify/Product/${shopifyId}") {
              productType
              variants(first: 250) {
                edges {
                  node {
                    id
                    globalid:metafield(namespace:"shirtup", key: "globalid"){
                      value
                    }
                    colorEN:metafield(namespace:"shirtup", key: "configurator_color"){
                      value
                    }
                    price{
                      amount
                    }
                    sku
                  }
                }
              }
            }
          }`
        })
      });
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
  authConflict(e) {
    window.location.href = '/404';
  }
  sendAccountToSavedDesignInKlaviyo(e){
    let userEmail = localStorage.getItem('users_email');
    
    _learnq.push(['identify', {
       '$email' : userEmail
       }]);
      _learnq.push(['track', 'Saved Design']);
  }

  setApiToken() {
    this.configurator.apiToken = localStorage.getItem('authToken');
    this.configurator.apiTokenExpiredDate = localStorage.getItem('authTokenExpiredAt');
  }

  async init() {
    this.configuratorData = this.getConfiguratorData();
    
    if(!localStorage.getItem('authToken')) {
      await (async () => {
       await this.authToken.getToken();
       this.setApiToken();         
            return this;
      })();  
    }
    this.setApiToken();
    const FOUR_HOUR = 14400000;
    const expiredAtSecond = this.authToken.timeToExpired() || FOUR_HOUR ;

    this.checkTokenIntervalId = setInterval(async () => {
       if (!this.authToken.isTokenValid()) {
         await this.authToken.getToken();
         this.setApiToken();
       }
     }, expiredAtSecond);

    var userId = this.configuratorData.userId;
       if (userId === "") {
       userId = localStorage.getItem("usersIds");
        // userId = userId.replace(/^"|"$/g, '');
      } 
    
    
    // await this.checkCartContents()
    var exchangeRate = Shopify.currency.rate;
    this.configuratorData.pricing.exchangeRate = parseFloat(exchangeRate);   
    
    this.configurator.productCustomTags = this.configuratorData.productCustomTags;
    this.fetchAllTranslatedProductTitles();
    this.configurator.lang = this.configuratorData.lang;
    this.configurator.langMarket = this.configuratorData.langMarket;
    this.configurator.fromCart = this.configuratorData.fromCart;
    this.configurator.productTranslation  = this.configuratorData.productTranslation;
    this.configurator.productColorTranslation  = this.configuratorData.productColorTranslation;
    this.configurator.userId = userId;
    this.configurator.userIsLoggedIn = this.configuratorData.userIsLoggedIn;
    this.configurator.fromSavedDesigns = this.configuratorData.fromSavedDesigns;
    this.configurator.nextShipping = this.configuratorData.nextShipping;
    this.configurator.baseShopUrl = this.configuratorData.baseShopUrl;
    this.configurator.productHandler = this.configuratorData.productHandler;
    this.configurator.webShopProduct = this.configuratorData.product;
    this.configurator.pricing = this.configuratorData.pricing;
    this.configurator.preselectedVariants  = this.configuratorData.preselectedVariants;
    this.configurator.mobileUxV2 = this.configuratorData.mobileUxV2;
    this.configurator.desktopUxV2 = this.configuratorData.desktopUxV2;
    this.configurator.weAdviseText = this.configuratorData.weAdviseText;
    this.configurator.exchangeRate = this.configuratorData.pricing.exchangeRate;
    this.configurator.content = this.configuratorData.content;
    this.configurator.discountRules = this.configuratorData.discountRules;

    let printTechniqueSelected = document.querySelector('.radio-btn:checked')?.value;

    if(printTechniqueSelected == 'DTG') {        
      this.configurator.webShopProduct.printTechnique =  'DTG';
    } else if (printTechniqueSelected == 'DTF') {        
      this.configurator.webShopProduct.printTechnique =  'DTF';
    }
    
    let designMode = {
      "mode": "USER_DESIGN",
      "readOnly": false
    };
    if (this.configuratorData.route == 'Customisable design') {
      designMode.mode = "PREDEFINED_DESIGN";
    }
   

    const params = (new URL(document.location)).searchParams;
    if (this.configuratorData.configuratorDesignId) {
        this.configurator.configuratorDesignId = this.configuratorData.configuratorDesignId;
    } else if (params.has('_configurator_design_id')) {
        this.configurator.configuratorDesignId = params.get('_configurator_design_id');
        if (params.has('readOnly')) {
          designMode = {
            "mode": "SHARED_DESIGN",
            "readOnly": true
          };
        }
        if (this.configuratorData.cart) {
            const cartVariants = this.configuratorData.cart.variants.filter(variant => variant._configurator_design_id === params['_configurator_design_id']);
            this.configuratorData.product.variants.map(variant => {
                const cartVariant = cartVariants.find( v => v.id == variant.id );
                if (cartVariant) {
                    variant.selectedQuantity = parseInt(cartVariant.selectedQuantity);
                }
                return variant;
            });
        }
    }
    this.configurator.designMode = designMode;    

    try {
    const cart = await fetch('/cart.js');
    const cartJson = await cart.json();
    const url = window.location.href;
    const urlObj = new URL(url);
    const params = new URLSearchParams(urlObj.search);
    const configuratorDesignId =  params.get('_configurator_design_id');
    if (configuratorDesignId !== null) {
    const isItemInCart = cartJson.items.some(item => item.properties._configurator_design_id === configuratorDesignId);
    this.configurator.fromCart = isItemInCart;
    }
    } catch (error) {
      console.error('Error fetching cart contents:', error);
    }
}


  getConfiguratorData() {
      this.configuratorData = this.configuratorData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.configuratorData;
  }
  getInitialConfiguratorData(){
    this.configuratorData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
  }
  updateConfiguratorData(updatedValues) {
    this.configuratorData = this.getConfiguratorData();
    this.configuratorData = this.mergeDeep(this.configuratorData, updatedValues);
  }
  designIdUpdate(ev) {
    if ('product' == this.dataset.page) {
      let path = window.location.href.split('?')[0]
      let currentHash = window.location.hash;
      let params = (new URL(document.location)).searchParams;
      params.set('_configurator_design_id', ev.detail);
      let newUrl = `${path}?${params.toString()}${currentHash}`;
      window.history.replaceState({ }, '', newUrl);
    }
  }

updateVariantsAfterColorChange(ev){
  const selectedVariantId = ev.detail.selectedVariants[0].variantId;
  const colorVariant = this.configuratorData.product.variantsStock.find(variant => variant.globalid === selectedVariantId);

  if (!colorVariant) {
      console.error('Selected variant not found in variantsStock.');
      return;
  }

  const color = colorVariant.color;
  const translatedColor = colorVariant.translatedColor;

  this.configuratorData.product.productColorTranslation = translatedColor;

  const colorVariants = this.configuratorData.product.variantsStock.filter(variant => variant.color === color);
  const resultVariants = colorVariants.map(variant => {
      const variantBeforeColorChange = this.configurator.webShopProduct.variants.find(x => x.size === variant.size);
      if (variantBeforeColorChange) {
          variant.selectedQuantity = variantBeforeColorChange.selectedQuantity;
      }
      return variant;
  });

  // Update configurator data
  this.configuratorData.product.variants = resultVariants;
  this.configuratorData.product.color = color;
  this.configurator.webShopProduct.variants = resultVariants;

  // Update URL if not on cart page
  if (window.location.pathname !== routes.cart_url) {
      const url = new URL(window.location);
      const params = new URLSearchParams(document.location.search);
      url.searchParams.set('_configurator_design_id', params.get('_configurator_design_id'));
      url.searchParams.set('variant', selectedVariantId);
      window.history.pushState(null, '', url.toString());
  }
}
formatPrice(price, country) {
  return country === "NL" ? (Shopify.formatMoney(price)).split(' ').reverse().join(' ') : Shopify.formatMoney(price);
}
calculateDiscountedPrice(basePrice, percentage) {
  return basePrice - (basePrice * (percentage / 100));
}
// prepareDiscounts(discounts, productTags, percentage) {
//   let copyDiscountGroup;
//   let newBreaks;
  
//   discounts.forEach(discountGroup => {
//       copyDiscountGroup = discountGroup;
//       if (productTags.includes(discountGroup.tag)) {
//         newBreaks = discountGroup.breaks.filter(breakItem => breakItem.percentage >= percentage);    
//         if(percentage != 0) {
//           newBreaks[0].quantity = 1;
//         }
//         copyDiscountGroup.breaks = newBreaks;
//       }
//   })

//   return copyDiscountGroup;
// }
prepareDiscounts(discounts, productTags, percentage) {
  let copyDiscountGroup;
  let newBreaks;

  discounts.forEach(discountGroup => {
      copyDiscountGroup = { ...discountGroup };

      if (productTags.includes(discountGroup.tag)) {
          newBreaks = discountGroup.breaks.filter(breakItem => breakItem.percentage >= percentage);

          if (percentage !== 0 && (!newBreaks.length || newBreaks[0].percentage !== percentage)) {
              newBreaks.unshift({
                  quantity: 1,
                  percentage: percentage,
                  message: `Quantity discount for ${percentage}% off`,
              });
          }

          copyDiscountGroup.breaks = newBreaks;
      }
  });

  return copyDiscountGroup;
}
setPercentageAndQuantity(ev) {
  let percentage = this.dataset.percentage ? parseFloat(this.dataset.percentage) : 0;
  let totalSelectedQuantity = ev.detail.selectedVariants.reduce((sum, variant) => sum + variant.quantity, 0);

  return { percentage, totalSelectedQuantity };
}
toFixed2(num, fixed) {
  const factor = Math.pow(10, fixed);

// Multiply to shift the decimals, inspect the third and fourth decimals
const extended = num * factor * 100; // Extend to inspect the third and fourth decimals
const thirdDecimal = Math.floor(extended / 10) % 10; // Extract the third decimal
const fourthDecimal = Math.floor(extended) % 10; // Extract the fourth decimal

// If the third decimal is 9 and there is a fourth decimal
if (thirdDecimal === 9 && fourthDecimal !== 0) {
  return (Math.ceil(num * factor) / factor).toFixed(fixed);
}

// Otherwise, truncate the number (round down)
return (Math.floor(num * factor) / factor).toFixed(fixed);
}
pricingRequested(ev) {      
  let subtotal= 0;  
  
  let oldSubtotal = 0;
  let discountTotal = 0;
  let quantityDiscountPerItem = '';
  let quantityDiscountPerItemPrice = 0;
  let total = 0;
  let oldTotal = 0;  
  let chargesTotalPrintingCharge = 0;
  let chargesTotalPrintingChargeFunction = 0;  
  let oldChargesPrintingCharge = 0;
  let charges = [];  

  let currentBreak = {};
  let isDiscounted = false;  
  
  let { percentage, totalSelectedQuantity } = this.setPercentageAndQuantity(ev);
  isDiscounted = percentage != 0;
  
  this.productTags = (this.dataset.tags) ? JSON.parse(this.dataset.tags) : this.configuratorData.tags;
  this.configuratorData = this.configuratorData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
  this.currencySign = this.dataset.currency;
  
  const printTechnique =  this.configuratorData.product.printTechnique;

  //Prepare bulk discounts based on percentage from settings 
  let copyDiscountGroup = {};
  if (this.dataset.discounts) {
    this.discounts = JSON.parse(this.dataset.discounts);
    if(this.discounts) {
      copyDiscountGroup = this.prepareDiscounts(this.discounts, this.productTags, percentage);
    }
  }  

  //Update color and variants after change color is triggered
  this.updateVariantsAfterColorChange(ev)

  this.configuratorData.pricing.discounts = [];
    
  if (this.discounts && this.productTags) {
    var TotalDiscountAllVariants = [];        
      
    if (this.productTags.includes(copyDiscountGroup.tag)) {
        const unreachedBreaks = copyDiscountGroup.breaks.filter(b => b.quantity > totalSelectedQuantity);
                  
        if (unreachedBreaks.length > 0) {
         const nextBreak = unreachedBreaks.reduce((prev, current) => (+prev.quantity < +current.quantity) ? prev : current);                    
          if (nextBreak) {
              const nextDiscount =  nextBreak.percentage;
              const nextDiscountPrice = parseInt(this.configuratorData.variants[0].price + chargesTotalPrintingCharge) * (nextBreak.percentage / 100);
              const discountDifference = nextBreak.quantity - totalSelectedQuantity;                  
              let discountMessage = window.discountStrings.messageOne.replace('1', discountDifference);
              if (discountDifference > 1) {
                discountMessage = window.discountStrings.messageOther.replace('2', discountDifference);
              }                
              this.configuratorData.pricing.discounts.push({
              type: "BULK",                    
              description: discountMessage.replace('[discount]', nextDiscount + '%'),
              price: this.formatPrice(nextDiscountPrice, Shopify.country)                 
            });                            
          }
        }
        const reachedBreaks = copyDiscountGroup.breaks.filter(b => b.quantity <= totalSelectedQuantity);            
        if (reachedBreaks.length > 0) {
          currentBreak = reachedBreaks.reduce((prev, current) => (+prev.quantity > +current.quantity) ? prev : current);            
          if (currentBreak) {
              percentage = currentBreak.percentage;
              quantityDiscountPerItem = currentBreak.percentage + '%';
              isDiscounted = percentage != 0;
          }
        }
      }        
  }

  if (printTechnique === 'DTF') {
    this.configuratorData.printingTechnique = "DTF";
    
      const thresholds = [
        { max: 250, variant: 'dtf1' },
        { max: 500, variant: 'dtf2' },
        { max: 750, variant: 'dtf3' },
        { max: Infinity, variant: 'dtf4' }
      ];
    
      ev.detail.pricingCalculation.printPositions.forEach((printPosition) => {
        printPosition.dtf.usedPrintAreasSurfaces.forEach((surface) => {
          const area = surface.usedAreaSurfaceInMm2/100;
    
          const matched = thresholds.find(t => area <= t.max);
          const variantTitle = matched.variant;
          const printVariant = this.configuratorData.printing_variants.find(
            v => v.title.toLowerCase() === variantTitle
          );
    
          if (printVariant) {
            let printPrice = printVariant.price;      
            chargesTotalPrintingChargeFunction = chargesTotalPrintingChargeFunction + printPrice;
            
            this.printingPrice = chargesTotalPrintingChargeFunction / Shopify.currency.rate;
            const printPriceCalculated = this.calculateDiscountedPrice(printPrice, percentage);
            
            chargesTotalPrintingCharge = chargesTotalPrintingCharge + (percentage != 0 ? printPriceCalculated : printPrice);
            oldChargesPrintingCharge = oldChargesPrintingCharge + (percentage != 0 ? printVariant.price : 0);
                      
            charges.push({
              type: "PRINTING_COST",
              description: printPosition.name,
              price: isDiscounted ? this.formatPrice(printPriceCalculated, Shopify.country) : this.formatPrice(printPrice, Shopify.country),
              oldPrice: isDiscounted ? this.formatPrice(printPrice, Shopify.country) : null            
            }); 
          }
        });
      });
    } else {
    this.configuratorData.printingTechnique = "DTG";
    
      ev.detail.selectedPrintPositions.forEach((printPosition, index) => {
        const printVariant = this.configuratorData.printing_variants.find(v => v.title.toLowerCase().includes(printPosition.name));
        if (printVariant) {
          let printPrice = printVariant.price;      
          chargesTotalPrintingChargeFunction = chargesTotalPrintingChargeFunction + printPrice;
          
          this.printingPrice = chargesTotalPrintingChargeFunction / Shopify.currency.rate;
          const printPriceCalculated = this.calculateDiscountedPrice(printPrice, percentage);
          
          chargesTotalPrintingCharge = chargesTotalPrintingCharge + (percentage != 0 ? printPriceCalculated : printPrice);
          oldChargesPrintingCharge = oldChargesPrintingCharge + (percentage != 0 ? printVariant.price : 0);
                    
          charges.push({
            type: "PRINTING_COST",
            description: printPosition.name,
            price: isDiscounted ? this.formatPrice(printPriceCalculated, Shopify.country) : this.formatPrice(printPrice, Shopify.country),
            oldPrice: isDiscounted ? this.formatPrice(printPrice, Shopify.country) : null            
          });          
        }
      });
    }

  if(percentage != 0) {
      var currentDiscountPercentage = percentage  / 100;
      quantityDiscountPerItemPrice = Number((this.configuratorData.variants[0].price + chargesTotalPrintingChargeFunction) * (currentDiscountPercentage));
      ev.detail.selectedVariants.forEach(variant => {
        TotalDiscountAllVariants.push(quantityDiscountPerItemPrice * variant.quantity)
    });
  }

  this.configuratorData.pricing.charges = charges;


  const calculatePriceIncludingCharges = (basePrice, charges) => basePrice + charges;
  const totalCharges = chargesTotalPrintingCharge;   

  isDiscounted = percentage != 0;
  let discountNewTotal = 0;
  
  this.configuratorData.pricing.items = Array.from(ev.detail.selectedVariants, variant => {
    const productVariant = this.configuratorData.product.variantsStock.find(v => v.globalid == variant.variantId);           
    const variantPrice = productVariant.price;
    const calculatedPrice = (((productVariant.price - this.toFixed2(((productVariant.price/100) * percentage),2))));
    
    variant.price = isDiscounted ? this.formatPrice(calculatedPrice, Shopify.country) : this.formatPrice(variantPrice, Shopify.country);
    variant.oldPrice = isDiscounted ? this.formatPrice(productVariant.price, Shopify.country) : null;
    // variant.priceIncludingCharges = this.formatPrice(calculatePriceIncludingCharges(isDiscounted ? calculatedPrice : productVariant.price, totalCharges), Shopify.country);            

    let calculatedPriceIncludingCharges = parseFloat((calculatePriceIncludingCharges(productVariant.price, chargesTotalPrintingChargeFunction)/100)) -  (parseFloat((this.toFixed2(((((productVariant.price + chargesTotalPrintingChargeFunction)/100)/100) * percentage),2))))      
    variant.priceIncludingCharges = this.formatPrice(calculatedPriceIncludingCharges * 100, Shopify.country);
    
    const oldCharges = (oldChargesPrintingCharge || chargesTotalPrintingCharge);    
    const variantTotal = isDiscounted ? calculatedPrice + totalCharges : productVariant.price + totalCharges;                    
    let oldVariantTotal = 0;
    
    if (variant.oldPrice || oldChargesPrintingCharge !== 0) {
      oldVariantTotal = (variant.oldPrice ? productVariant.price : calculatedPrice) + (oldChargesPrintingCharge !== 0 ? oldChargesPrintingCharge : chargesTotalPrintingCharge);
      variant.oldPriceIncludingCharges = this.formatPrice(oldVariantTotal,Shopify.country);
    } else {
      variant.oldPriceIncludingCharges = null;
    }

    let variantSubtotal = ((productVariant.price + chargesTotalPrintingChargeFunction) * variant.quantity) / 100;
    
    let discountPerVariant = (((variantSubtotal / variant.quantity)/100).toFixed(4)) * percentage;
    
    // if(discountPerVariant.toString().split('.')[1].length <= 3) {
    //  discountPerVariant = Math.floor(discountPerVariant * 100) / 100;
    // }
    const decimalPart = discountPerVariant.toString().split('.')[1];
    if (!decimalPart || decimalPart.length <= 3) {
        discountPerVariant = Math.floor(discountPerVariant * 100) / 100;
    }

    
    let variantSubtotalDiscounted = discountPerVariant * variant.quantity;  
    
    variantSubtotalDiscounted = Math.floor(variantSubtotalDiscounted * 100) / 100;
    
    discountNewTotal = discountNewTotal + variantSubtotalDiscounted;          
    subtotal = subtotal + parseFloat((variantSubtotal-variantSubtotalDiscounted).toFixed(2))
    oldSubtotal = oldSubtotal + (oldVariantTotal * variant.quantity);
    
    return variant;
  });

  if(TotalDiscountAllVariants) {
    for (let i = 0; i < TotalDiscountAllVariants.length; i++) {
      let truncated = TotalDiscountAllVariants[i];
      discountTotal += (truncated);
    }
  }

  discountTotal = discountNewTotal * 100;


  total = isDiscounted ? (((oldSubtotal/100) - discountNewTotal)*100) : subtotal * 100;
  oldTotal = oldSubtotal != 0 ? oldSubtotal : 0;
  subtotal = subtotal * 100;  

  let freeShippingMinimum = parseInt(this.dataset.freeShipping);
  let cartTotal = (this.configuratorData.cartTotal !== undefined) ? this.configuratorData.cartTotal : parseInt(this.dataset.cartTotal);
  const cartProductTotal = (cartTotal + total);

  if (cartProductTotal < freeShippingMinimum) {
    const shippingDifference = freeShippingMinimum - cartProductTotal;
    let shippingMessage = window.discountStrings.shippingMessage;
      this.configuratorData.pricing.discounts.push({
      type: "FREE_SHIPPING",
      description: shippingMessage.replace('[total]', this.formatPrice(shippingDifference, Shopify.country)),
      price: this.formatPrice(shippingDifference, Shopify.country)
    });          
  }

  this.configuratorData.pricing.subtotal = this.formatPrice(subtotal, Shopify.country);
  this.configuratorData.pricing.oldSubtotal = oldSubtotal != 0 ? this.formatPrice(oldSubtotal, Shopify.country) : null;
  this.configuratorData.pricing.total = this.formatPrice(total, Shopify.country);
  this.configuratorData.pricing.oldTotal = oldTotal != 0 ? this.formatPrice(oldTotal, Shopify.country) : null;

  this.configuratorData.pricing.discountTotal = false;
  this.configuratorData.pricing.quantityDiscountPerItem = false;
  if (discountTotal > 0) {                
      this.configuratorData.pricing.discountTotal = this.formatPrice(discountTotal, Shopify.country);
      this.configuratorData.pricing.quantityDiscountPerItem  = quantityDiscountPerItem;
  }
  this.configuratorData.pricing.priceValue = Math.round(total) / 100;
  this.configurator.pricing = this.configuratorData.pricing;
}

  async generateCart(ev) {
    this.readyToRedirect = false;
    this.configurator.configuratorDesignId = ev.detail.configuratorDesignId;
    let designid = ev.detail.configuratorDesignId;
    await fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then(async (cart) => {
        this.selectedPrintPositions = ev.detail.selectedPrintPositions;
        this.selectedVariants = ev.detail.selectedVariants;
        if (!this.selectedVariants) {
          this.selectedVariants = this.configuratorData.pricing.items;
        }
        const items = this.configuratorData.product.variants.map(item => {
          const itemVariant = this.selectedVariants.find(selecteditem => selecteditem.variantId == item.globalid);
          item.quantity = 0;
          if (itemVariant) {
            item.orderDesignId = ev.detail.orderDesignId;
            item.designName = ev.detail.designName;
            item.smakeVariantId = ev.detail.smakeVariantId;
            item.quantity = itemVariant.quantity;
          }
          return item;
        });
        const positions = this.configuratorData.printing_variants.map(position => {
          const printPosition = this.selectedPrintPositions.find(selectedPosition => position.title.toLowerCase().includes(selectedPosition.name));
          position.selected = false;
          if (printPosition) {
            position.printPositionId = printPosition.id;
            position.selected = true;
          }
          return position;
        });

        const designId = this.configurator.configuratorDesignId;
        const cartItemsPositions = cart.items.filter(variant => variant.properties['_configurator_design_id'] === designId);

        const newItems = items.filter(item => item.quantity > 0);
        const newPositions = positions.filter(position => position.selected);

        if (cartItemsPositions.length !== 0) {
          let keys = []
          for (let i = 0; i < cart.items.length; i++) {
            if (cart.items[i] === cartItemsPositions[0]) {
              for (let j = 0; j < cartItemsPositions.length; j++, i++) {
                keys.push(cart.items[i].key)
              }
              break
            }
          }
          let updates = {}
          keys.forEach(key => {
            updates[key] = 0;
          });
          const body = JSON.stringify({
            updates: updates
          });
          await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
            })
        }
        this.readyToRedirect = false;

        if(ev.detail.selectedElements.length > 0) {
          const variants = this.createItems(newItems, newPositions, true)
          if (variants.length) {
            const body = {
              'items': variants
            };
            const config = fetchConfig('json');
            config.headers['credentials'] = 'same-origin';
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            config.body = JSON.stringify(body);
            await fetch(`${routes.cart_add_url}.js`, config)
              .then((response) => response.json())
              .then((response) => {
                this.configurator.dispatchEvent(new CustomEvent('cartModified'));
                if (this.cartItemsToUpdate.length) {
                  this.updateProperties();
                }
                this.readyToRedirect = true;
              })
              .catch((e) => {
                console.error(e);
              });
          }
        }
        this.readyToRedirect = true;
      })
  }

 redirect(ev){
  const redirect=ev.detail.redirect;
  switch(redirect){
    case 'HOME':
    this.redirectHome();
    break;
    case 'CART':
    this.redirectCart();
    break;
    case 'NON':
    break;
    default : 
    console.log('error in catching redirect field')
   }
 }
 redirectHome(){
   if(this.readyToRedirect === true){
   window.location.href = window.Shopify.routes.root;
   }
   else{
    setTimeout(() => {
      this.redirectHome();
    }, 500);
   }
  }
  redirectCart(){
    if(this.readyToRedirect === true){
      window.location.href = routes.cart_url;
      }
      else{
       setTimeout(() => {
         this.redirectCart();
       }, 500);
      }
  }
  
   createItems(items, positions, includeItems = false) {
      const designId = this.configurator.configuratorDesignId;
      let variants = [];
      let variant;      
      let printPrice = this.printingPrice;
      
      items.forEach((itemVariant,index) => {        
          if (includeItems) {
              const itemVariantId = itemVariant.id == '01387840-8E49-4F17-B3E5-EE4ED76A1C91' ? 7943041417446 : itemVariant.id;
              variant = {
                  quantity: itemVariant.quantity,                  
                  id: itemVariantId,
                  price: itemVariant.price,
                  properties: {
                      '_designName': itemVariant.designName,
                      '_type': 'configurator_product',
                      '_configurator_design_id': designId,
                      '_country': Shopify.country,
                      '_smake_variant_id': itemVariant.smakeVariantId,
                      '_order_design_id': itemVariant.orderDesignId,
                      '_print_positions': this.selectedPrintPositions.map(p => p.id).join(','),
                      '_print_price': printPrice,
                      '_print_technique': this.configuratorData.printingTechnique
                  }
              };
              variants.push(variant);
          }
      });
      return variants;
  }


  addNew(newItems, positions, existingItems, newPositions) {
      const variants = this.createItems(newItems, positions, true).concat(this.createItems(existingItems, newPositions));
      if (variants.length) {
          this.cartAdd(variants);
          return true;
      }
      return false;
  }

  createUpdates(cartItems, cartPositions, existingItems, positions) {
      const printPositionsIds = this.selectedPrintPositions.map(p => p.id).join(',');
      let itemsToUpdate = {};
      cartItems.forEach(cartItem => {
          if (cartItem.properties._print_positions !== printPositionsIds) {
              cartItem.properties._print_positions = printPositionsIds;
              this.cartItemsToUpdate.push(cartItem);
          }
          const item = existingItems.find(item => item.id == cartItem.variant_id);
          if (item) {
              if (cartItem.quantity !== item.quantity) {
                  itemsToUpdate[cartItem.key] = item.quantity;
              }
              // Find positions in the cart where property line id matches current line item variant id.
              cartPositions.filter(cartPosition => cartPosition.properties._for_line_item_id == cartItem.variant_id).forEach(cartPosition => {
                  // Find position variant 
                  const position = positions.find(position => position.id === cartPosition.variant_id);
                  if (position && !position.selected) {
                      itemsToUpdate[cartPosition.key] = 0
                  } else if (cartPosition.quantity !== item.quantity) {
                      itemsToUpdate[cartPosition.key] = item.quantity;
                  }
              });
          }
      });
      return itemsToUpdate;
  }
  
  updateExisting(cartItems, cartPositions, existingItems, positions) {
      if (existingItems.length) {
          const items = this.createUpdates(cartItems, cartPositions, existingItems, positions);
          if (Object.keys(items).length) {
              this.cartUpdate(items);
          }
      }
  }

  updateProperties() {
      if (this.cartItemsToUpdate.length) {
          const cartItem = this.cartItemsToUpdate.shift();
          const item = {
              'id': cartItem.key,
              'properties': cartItem.properties
          };
          this.cartChange(item);
      }
  }

  cartAdd(preparedItems) {
      const body = {
          'items': preparedItems
      };
      this.cartAction(routes.cart_add_url, body);
  }

  cartUpdate(preparedItems) {
      const body = {
          'updates': preparedItems
      };
      this.cartAction(routes.cart_update_url, body);
  }

  cartChange(body) {
      this.cartAction(routes.cart_change_url, body);
  }

  cartAction(route, body) {
      const config = fetchConfig('json');
      config.headers['credentials'] = 'same-origin';
      config.headers['X-Requested-With'] = 'XMLHttpRequest';

      config.body = JSON.stringify(body);

      fetch(`${route}.js`, config)
      .then((response) => response.json())
      .then((response) => {
          this.configurator.dispatchEvent(new CustomEvent('cartModified'));
          if (this.cartItemsToUpdate.length) {
              this.updateProperties();
          }

      })
      .catch((e) => {
          console.error(e);
      });
  }

  isObject(item) {
      return (item && typeof item === 'object' && !Array.isArray(item));
  }
  mergeDeep(target, ...sources) {
      if (!sources.length) return target;
      const source = sources.shift();
    
      if (this.isObject(target) && this.isObject(source)) {
        for (const key in source) {
          if (this.isObject(source[key])) {
            if (!target[key]) Object.assign(target, { [key]: {} });
            this.mergeDeep(target[key], source[key]);
          } else {
            Object.assign(target, { [key]: source[key] });
          }
        }
      }
    return this.mergeDeep(target, ...sources);
      
  }
}
customElements.define('product-configurator', ProductConfigurator);


class ConfiguratorTrigger extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', function(event) {
      if (this.hasAttribute('disabled')) {
        event.preventDefault();
        const tooltipSpan = document.getElementById('tooltip-text');
        const tooltipText = tooltipSpan ? tooltipSpan.textContent : '';
        let tooltip = this.querySelector('.tooltip');

        if (!tooltip) {
          tooltip = document.createElement('div');
          tooltip.className = 'tooltip';
          tooltip.textContent = tooltipText;
          this.appendChild(tooltip);
        }
    
        tooltip.style.display = 'block';

        setTimeout(() => {
          tooltip.style.display = 'none';
        }, 3000); // Hide tooltip after 3 seconds
      } else {
        this.openConfigurator();
      }
    }.bind(this));
    this.productConfigurator = (this.dataset.configurator) ? document.querySelector('product-configurator[data-section="' + this.dataset.configurator + '"]') : document.querySelector('product-configurator');
  }
  openConfigurator() {
    const dataset = this.dataset;
    this.productConfigurator = this.productConfigurator || document.querySelector('product-configurator');
    let currentURL = new URL(window.location.href);

    if (currentURL.pathname.includes("saved-designs")) {
      currentURL.searchParams.set('variant', dataset.configuratorVariantId);
      currentURL.searchParams.set('_configurator_design_id', dataset.configuratorDesignId);

      history.replaceState(null, '', currentURL.href);
    } else if (currentURL.pathname.includes("orders")) {
      currentURL.searchParams.set('_configurator_design_id', dataset.configuratorDesignId);

      history.replaceState(null, '', currentURL.href);
    }
    
   var myEle = document.getElementById("dummy-chat-button-iframe"); 
   if(myEle) {
     myEle.style.display = "none"
   } 
    if (dataset.variants) {
      if (this.productConfigurator.dataset.tags) {
        this.productConfigurator.dataset.tags = this.dataset.tags;
      }

      console.log('this.productConfigurator', this.productConfigurator.dataset)
      
      const variants = JSON.parse(dataset.variants);
      const productType = JSON.parse(dataset.productType);
      const product_variants = JSON.parse(dataset.productVariants);
      const variantsOnStock = JSON.parse(dataset.productVariantsstock)
      const premiumGraphicProduct = JSON.parse(dataset.productPremiumgraphic)
      const sizesTableArray = JSON.parse(dataset.productProductimagesizes);
      const eventData = {
        bubbles: true,
        detail: {
          variants: variants,
          productHandler: dataset.productHandler,
          baseShopUrl: dataset.baseShopUrl,
          configuratorDesignId: dataset.configuratorDesignId,
          tags:JSON.parse(dataset.tags),          
          printing_variants: productType === "Bag" ?  getHoodieProduct() : getBasePrint(),
          product: {
            productSizeImageLink: dataset.productProductsizeimagelink,
            productImageSizes: sizesTableArray,
            productTranslation: JSON.parse(dataset.productProducttranslation),
            productColorTranslation: JSON.parse(dataset.productProductcolortranslation),
            id: dataset.productId,
            color:  dataset.color,
            quality: dataset.quality,
            variants: product_variants,
            variantsStock: variantsOnStock,
            premiumGraphic: premiumGraphicProduct
          }
        }
      };
      this.productConfigurator.dispatchEvent(new CustomEvent('shirtup:configure', eventData));
    } else {
      this.productConfigurator.dispatchEvent(new CustomEvent('shirtup:render', { bubbles: true }));
    }
  }
}
customElements.define('configurator-trigger', ConfiguratorTrigger);

class DiscountMessage extends HTMLElement {
  constructor() {
    super();
    this.productTags = JSON.parse(this.dataset.tags);
    this.quantity = parseInt(this.dataset.quantity);
    this.percentage = parseInt(this.dataset.percentage);
    this.variantPrice = parseInt(this.dataset.price);
    if (this.dataset.discounts) {
        this.discounts = JSON.parse(this.dataset.discounts);
    }    

  let copyDiscountGroup;
  let newBreaks;
  
  this.discounts.forEach(discountGroup => {
    copyDiscountGroup = { ...discountGroup };

    if (this.productTags.includes(discountGroup.tag)) {
      newBreaks = discountGroup.breaks.filter(breakItem => breakItem.percentage >= this.percentage);

      if (this.percentage !== 0 && (!newBreaks.length || newBreaks[0].percentage !== this.percentage)) {
          newBreaks.unshift({
              quantity: 1,
              percentage: this.percentage,
              message: `Quantity discount for ${this.percentage}% off`,
          });
      }

      copyDiscountGroup.breaks = newBreaks;
    }
  })

  this.discounts = copyDiscountGroup;

    this.discountCode = parseFloat(this.dataset.discountCode) || 0;
    this.render();
  }
  render() {
    // if (this.discounts && this.productTags && this.quantity) {
      // this.discounts.forEach(discountGroup => {
        
        if (this.productTags.includes(this.discounts.tag)) {
            const unreachedBreaks = this.discounts.breaks.filter(b => b.quantity > this.quantity);
            const reachedBreaks = this.discounts.breaks.filter(b => b.quantity <= this.quantity);
            
            if (unreachedBreaks.length > 0) {
                // const currentBreak = reachedBreaks.reduce((prev, current) => (+prev.quantity > +current.quantity) ? prev : current);
                //const nextBreak = unreachedBreaks.reduce((prev, current) => (+prev.quantity < +current.quantity) ? prev : current);
                  let nextBreak = unreachedBreaks.find(b => b.percentage > this.discountCode);
      
                  if (!nextBreak) {
                    nextBreak = unreachedBreaks.reduce((prev, current) => (+prev.quantity < +current.quantity) ? prev : current);
                  }
                if (nextBreak) {
                    const nextDiscount = nextBreak.percentage + '%' ;
                    const discountDifference = nextBreak.quantity - this.quantity;
                    
                    // Discount upsell
                    let discountMessage = window.discountStrings.messageCartOne.replace('1', discountDifference);
                    if (discountDifference > 1) {
                      discountMessage = window.discountStrings.messageCartOther.replace('2', discountDifference);
                     }
                    this.innerHTML = discountMessage.replace('[discount]', nextDiscount);
                }
            }
        }
      // });
    // }
  }
}
customElements.define('discount-message', DiscountMessage);

function updateSizesArrayFinder(root = document) {
  const sizes = root.querySelectorAll('.sizes-array-finder');
  if (!sizes.length) return;

  const order = {
    XXS: -1, XS: 0, S: 1, M: 2, L: 3, XL: 4, XXL: 5, '3XL': 6, '4XL': 7, '5XL': 8,
    '06M': 9, '12M': 10, '18M': 11, '23M': 12, '2Y': 13, '4Y': 14, '6Y': 15, '8Y': 16, '10Y': 17, '12Y': 18
  };

  sizes.forEach(size => {
    const orderValues = size.getAttribute('data-order');
    if (!orderValues) return;

    const orders = orderValues.split(',');

    orders.sort((a, b) => {
      if (!(a in order) && !(b in order)) return 0;
      if (!(a in order)) return 1;
      if (!(b in order)) return -1;
      return order[a] - order[b];
    });

    if (orders.length > 0) {
      const firstSpan = size.querySelector('span');
      if (firstSpan) {
        firstSpan.textContent = orders[0];
        if (orders.length > 1) {
          firstSpan.textContent = `${firstSpan.textContent} - ${orders[orders.length - 2]}`;
        }
      }
    }
  });
}

window.updateSizesArrayFinder = updateSizesArrayFinder;
updateSizesArrayFinder();


document.addEventListener('DOMContentLoaded', ()=>{
  let accordions = document.querySelectorAll('.accordion_headline');
  
  if(accordions) {
    accordions.forEach((headline) => {
      headline.addEventListener('click', function () {
        const content = this.nextElementSibling;
        const svg = this.querySelector('svg');        

        // If the accordion is closed, open it
        if (content.style.maxHeight === "" || content.style.maxHeight === "0px") {
          if(content.classList.contains('active-facets')) {
            content.style.maxHeight = 'fit-content';
          } else {
            content.style.maxHeight = content.scrollHeight + "px"; // Expand to the full height of the content               
          }
          svg.classList.add('accordion_icon_rotate');
          if(content.classList.contains('accordion_content_overflow')) {
            content.style.overflow = 'visible';
          }
        } else {
          content.style.maxHeight = "0px"; // Collapse the accordion
          svg.classList.remove('accordion_icon_rotate')
          if(content.classList.contains('accordion_content_overflow')) {          
            content.style.overflow = 'hidden';
          }
        }
      });
    });
  }
})

// POPUP FETCHING PAGE WHEN PAGE CONTENT IS EMPTY
let items = document.querySelectorAll('.popup-page-fetcher');
if(items) {
items.forEach(item => {
  item.addEventListener("click", function(event) {
    
    try {
      const opener = event.currentTarget;
      if (!opener) {
        throw new Error('Failed to find the modal opener element');
      }

      var country = Shopify.country;
      var locale = Shopify.locale;
      var activeMarkets = ['es', 'de', 'fr', 'nl', 'sv', 'pl', 'it'];

      if (!activeMarkets.includes(locale)) {   
        locale = ''; // Fallback to no locale
      }
      
      const handle = item.dataset.handle;

      
      // const url = locale ? `${window.location.origin}/${locale}-${country}/pages/delivery-information` : `${window.location.origin}/pages/delivery-information`;
      const url = locale ? `${window.location.origin}/${locale}-${country}/pages/${handle}` : `${window.location.origin}/pages/${handle}`;

      fetch(url)
        .then(response => response.text())
        .then(data => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, "text/html");
          const hero = doc.getElementById('MainContent')?.innerHTML || '';

          const modalId = opener.getAttribute('data-modal'); // "#PopupModal-<block.id>"
          const modal = document.querySelector(modalId);
          
          if (!modal) {
            throw new Error(`Modal with ID ${modalId} not found`);
          }

          const modalContent = modal.querySelector(".product-popup-modal__content-info-content");

          if (modalContent) {
            modalContent.innerHTML = hero;
          } else {
            throw new Error('Modal content element not found');
          }
        })
        .catch(error => console.error('Error fetching content:', error));

    } catch (error) {
      console.error('An error occurred:', error);
    }
  });
});
}

